import { gql } from '@apollo/client';

const GET_INFLUENCERS = gql`
  query GetInfluencers($mode: Int) {
    creators(input: { filters: { mode: $mode } }) {
      id
      communityId
      tier
      mediaCover {
        cdn01
        image
      }
      firstName
      lastName
      latestWorkout {
        publishedAt
      }
      isVisible
      publishedAt
      customizations {
        isNewVideo
        canUsePromotionDetails
        canUsePromotions
        premiumFeaturesOTPIds
      }
    }
  }
`;

export const GET_INFLUENCERS_NAMES = gql`
  query GetInfluencers {
    creators {
      id
      firstName
      lastName
    }
  }
`;

const GET_STREAM_KEY = gql`
  query GetStreamKey($id: Int!) {
    creator(id: $id) {
      id
      liveStreamKey
    }
  }
`;

export const GET_INFLUENCER = gql`
  query GetInfluencer($id: Int!) {
    creator(id: $id) {
      id
      tier
      mediaCover {
        cdn01
        image
      }
      mediaAvatar {
        cdn01
        image
      }
      firstName
      lastName
      liveStreamKey
      latestWorkout {
        publishedAt
      }
      isVisible
      publishedAt
      customizations {
        isNewVideo
        canUsePromotionDetails
        canUsePromotions
        premiumFeaturesOTPIds
        isTransactionLedgerEnabled
        isUnifiedProgramsEnabled
        isCommunitiesV2Enabled
        isCommunityContentEditEnabled
        isOtpMigratedToBundle
        isOffers35Enabled
        isCouponWithFreeTrialEnabled
        isCreatorApprovedSwapsEnabled
      }
      communityId
    }
  }
`;

export const GET_INFLUENCER_CLASSES = gql`
  query GetInfluencerClasses($influencerId: Int!) {
    influencerClasses(influencerId: $influencerId) {
      id
      cover {
        source
        cdn01
        image
        video
        audio
        height
        width
        mimeType
      }
      color
      name
      description
      duration
      schedule
      deepLink
      type
      difficulty
      location
      category
    }
  }
`;
